import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../../imageService';
import HeadContainer from '../../../../common/head-container';
import classNames from "classnames";

const AttemptsExhausted = ({
  setScreenNumber,
  telegramLink,
  checkPhoneNumber,
  isDarkMode = false
}) => {
  return (
    <div
      className={classNames(styles.container, isDarkMode && styles.darkContainer)}
      style={{
        backgroundImage: isDarkMode ? '' : `url("${getImageFromS3('images/ua-hostess/bg.png')}")`
      }}
    >
      <HeadContainer
        setScreenNumber={setScreenNumber}
        customTelegramLink={telegramLink}
        telegramOnly
      />
      <div className={styles.content}>
        <p className={styles.title}>Спроби вичерпані:(</p>
        <p className={styles.description}>
          Спробуй перевірити вказаний номер телефону та зареєструватися знову!
        </p>
        <button onClick={checkPhoneNumber} className={classNames(isDarkMode && styles.goldButton)}>
          {isDarkMode && <img src="/images/gold-button.png" alt="gold-button" />}
          <span>Перевірити номер</span>
        </button>
      </div>
    </div>
  );
};

export default AttemptsExhausted;
